// extracted by mini-css-extract-plugin
export default {"functionCallButton":"FunctionCallButton-module__functionCallButton--CUec3"};